export class RecorderAlreadyEnabledForLocationError extends Error {
  constructor(err: Error) {
    super(err.message)
    Object.setPrototypeOf(this, RecorderAlreadyEnabledForLocationError.prototype)
  }
}
